// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q7q5","toggleWrap":"styles_toggleWrap__1XUje","content":"styles_content__1XaEM","selectAreaCode":"styles_selectAreaCode__OD1l_"};